import i18n from '@/Language';
import { MessageBox } from 'element-ui';
export default {
    namespaced: true,
    state: {
        token: window.localStorage.getItem("newToken") || '',
        tokenChangeNotification: false, // 用于存储Token变更的通知状态
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        NOTIFY_TOKEN_CHANGE(state, notify) {
            state.tokenChangeNotification = notify;
        },
    },
    actions: {
        onTokenChange({ commit, state }, token) {
            if (token !== state.token) {
                MessageBox(i18n.t("common.environmentChange"), i18n.t("common.tip"), {
                  confirmButtonText: i18n.t("common.confirm"),
                  cancelButtonText: i18n.t("common.cancel"),
                  type: 'warning'
                }).then(() => {
                  window.location.replace("/")
                })
                commit('SET_TOKEN', token);
                // 检查是否是因为切换标签导致的Token变化并通知用户
                if (!state.tokenChangeNotification) {
                    commit('NOTIFY_TOKEN_CHANGE', true);
                    setTimeout(() => commit('NOTIFY_TOKEN_CHANGE', false), 6000); // 6秒后自动关闭通知
                }
            }
        },

        updateToken({ commit, state }, token) {
            commit('SET_TOKEN', token);
        }
    }
}
